<template>
  <div class="company-cta-wrapper tw-bg-white">
    <h2 class="text-center m-t-0">{{ $t('Welcome. How to get started quickly.') }}</h2>

    <div class="row-flex">
      <div class="col">
        <div class="visible-xs"><br /></div>
        <div class="m-b-15 line-height-1">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 22.0001C14.9641 21.9985 13.9462 21.7287 13.0454 21.217C12.1447 20.7053 11.3918 19.9691 10.86 19.0801L9.14999 20.0801C9.86193 21.2602 10.8667 22.2363 12.0668 22.9139C13.2669 23.5915 14.6218 23.9476 16 23.9476C17.3782 23.9476 18.733 23.5915 19.9332 22.9139C21.1333 22.2363 22.1381 21.2602 22.85 20.0801L21.14 19.0801C20.6082 19.9691 19.8553 20.7053 18.9546 21.217C18.0538 21.7287 17.0359 21.9985 16 22.0001Z"
              fill="black"
            />
            <path d="M30 4H26V0H24V4H20V6H24V10H26V6H30V4Z" fill="black" />
            <path
              d="M11.5 11.0001C11.0055 11.0001 10.5222 11.1467 10.1111 11.4214C9.69995 11.6961 9.37952 12.0866 9.1903 12.5434C9.00108 13.0002 8.95157 13.5029 9.04804 13.9878C9.1445 14.4728 9.3826 14.9182 9.73223 15.2678C10.0819 15.6175 10.5273 15.8556 11.0123 15.952C11.4972 16.0485 11.9999 15.999 12.4567 15.8098C12.9135 15.6206 13.304 15.3001 13.5787 14.889C13.8534 14.4779 14 13.9945 14 13.5001C14.0027 13.171 13.9398 12.8447 13.8151 12.5402C13.6904 12.2357 13.5064 11.9591 13.2737 11.7264C13.041 11.4937 12.7644 11.3096 12.4599 11.185C12.1553 11.0603 11.829 10.9974 11.5 11.0001Z"
              fill="black"
            />
            <path
              d="M20.5 11.0001C20.0055 11.0001 19.5222 11.1467 19.1111 11.4214C18.7 11.6961 18.3795 12.0866 18.1903 12.5434C18.0011 13.0002 17.9516 13.5029 18.048 13.9878C18.1445 14.4728 18.3826 14.9182 18.7322 15.2678C19.0819 15.6175 19.5273 15.8556 20.0123 15.952C20.4972 16.0485 20.9999 15.999 21.4567 15.8098C21.9135 15.6206 22.304 15.3001 22.5787 14.889C22.8534 14.4779 23 13.9945 23 13.5001C23.0027 13.171 22.9398 12.8447 22.8151 12.5402C22.6904 12.2357 22.5064 11.9591 22.2737 11.7264C22.041 11.4937 21.7644 11.3096 21.4599 11.185C21.1553 11.0603 20.829 10.9974 20.5 11.0001Z"
              fill="black"
            />
            <path
              d="M27.61 13C27.8627 13.9802 27.9936 14.9878 28 16C28 18.3734 27.2962 20.6935 25.9776 22.6668C24.6591 24.6402 22.7849 26.1783 20.5922 27.0866C18.3995 27.9948 15.9867 28.2324 13.6589 27.7694C11.3311 27.3064 9.19295 26.1635 7.51472 24.4853C5.83649 22.8071 4.6936 20.6689 4.23058 18.3411C3.76756 16.0133 4.0052 13.6005 4.91345 11.4078C5.8217 9.21509 7.35977 7.34094 9.33316 6.02237C11.3066 4.70379 13.6266 4 16 4V2C13.102 1.99901 10.2751 2.89738 7.90929 4.57118C5.5435 6.24498 3.75545 8.61171 2.79182 11.3448C1.8282 14.078 1.73649 17.0428 2.52935 19.8302C3.32221 22.6177 4.96057 25.0904 7.21838 26.9072C9.47619 28.724 12.2422 29.7954 15.1347 29.9735C18.0273 30.1517 20.9038 29.4277 23.3675 27.9017C25.8311 26.3756 27.7605 24.1226 28.8894 21.4535C30.0183 18.7844 30.291 15.8307 29.67 13H27.61Z"
              fill="black"
            />
          </svg>
        </div>
        <h4 class="f-500 hidden-sm f-18">1. {{ $t('Create your own talent pool') }}</h4>
        <h4 class="f-500 visible-sm f-14">1. {{ $t('Create your own talent pool') }}</h4>
        <p class="f-14 f-300 m-0">
          {{ $t('Build your own talent pool by adding your candidates.') }}
        </p>
      </div>

      <div class="col">
        <div class="visible-xs"><br /></div>
        <div class="m-b-15 line-height-1">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9ZM5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9ZM20 30H22V25C22 21.134 18.866 18 15 18H9C5.13401 18 2 21.134 2 25V30H4V25C4 22.2386 6.23858 20 9 20H15C16.3261 20 17.5979 20.5268 18.5355 21.4645C19.4732 22.4021 20 23.6739 20 25V30ZM19.2902 15.9645C19.2641 15.952 19.2379 15.9397 19.2117 15.9276C19.7814 15.3347 20.2786 14.6717 20.6893 13.9529C23.1245 13.6171 25 11.5276 25 9C25 6.47243 23.1245 4.3829 20.6893 4.04712C20.2727 3.31787 19.767 2.64612 19.1869 2.04671C19.4537 2.01586 19.725 2 20 2C23.866 2 27 5.13401 27 9C27 12.866 23.866 16 20 16C19.7604 16 19.5236 15.988 19.2902 15.9645ZM26.5355 21.4645C25.7619 20.6909 24.7609 20.1969 23.6896 20.0478C23.2621 19.2993 22.7407 18.6113 22.1414 18H23C26.866 18 30 21.134 30 25V30H28V25C28 23.6739 27.4732 22.4021 26.5355 21.4645Z"
              fill="#0E0D12"
            />
          </svg>
        </div>
        <h4 class="f-500 hidden-sm f-18">2. {{ $t('Submit candidates') }}</h4>
        <h4 class="f-500 visible-sm f-14">2. {{ $t('Submit candidates') }}</h4>
        <p class="f-14 f-300 m-0">
          {{ $t('Submit candidates to the jobs shared by your clients.') }}
        </p>
      </div>

      <div class="col">
        <div class="visible-xs"><br /></div>
        <div class="m-b-15 line-height-1">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M23 16H21V18H23V16Z" fill="black" />
            <path d="M17 16H9V18H17V16Z" fill="black" />
            <path d="M23 12H21V14H23V12Z" fill="black" />
            <path d="M17 12H9V14H17V12Z" fill="black" />
            <path d="M23 8H9V10H23V8Z" fill="black" />
            <path
              d="M25 2H7C6.46973 2.00053 5.96133 2.21141 5.58637 2.58637C5.21141 2.96133 5.00053 3.46973 5 4V29C5 29.2652 5.10536 29.5196 5.29289 29.7071C5.48043 29.8946 5.73478 30 6 30H7C7.15526 30.0001 7.30841 29.964 7.44728 29.8946C7.58615 29.8251 7.70692 29.7243 7.8 29.6L10 26.667L12.2 29.6C12.2971 29.7182 12.4192 29.8135 12.5576 29.8789C12.6959 29.9442 12.847 29.9781 13 29.9781C13.153 29.9781 13.3041 29.9442 13.4424 29.8789C13.5808 29.8135 13.7029 29.7182 13.8 29.6L16 26.667L18.2 29.6C18.2971 29.7182 18.4192 29.8135 18.5576 29.8789C18.6959 29.9442 18.847 29.9781 19 29.9781C19.153 29.9781 19.3041 29.9442 19.4424 29.8789C19.5808 29.8135 19.7029 29.7182 19.8 29.6L22 26.667L24.2 29.6C24.2931 29.7242 24.4139 29.8251 24.5527 29.8945C24.6916 29.9639 24.8447 30.0001 25 30H26C26.2652 30 26.5196 29.8946 26.7071 29.7071C26.8946 29.5196 27 29.2652 27 29V4C26.9994 3.46975 26.7885 2.9614 26.4135 2.58646C26.0386 2.21152 25.5302 2.00061 25 2ZM25 27.333L22.8 24.4C22.7029 24.2818 22.5808 24.1865 22.4424 24.1211C22.3041 24.0558 22.153 24.0219 22 24.0219C21.847 24.0219 21.6959 24.0558 21.5576 24.1211C21.4192 24.1865 21.2971 24.2818 21.2 24.4L19 27.333L16.8 24.4C16.7029 24.2818 16.5808 24.1865 16.4424 24.1211C16.3041 24.0558 16.153 24.0219 16 24.0219C15.847 24.0219 15.6959 24.0558 15.5576 24.1211C15.4192 24.1865 15.2971 24.2818 15.2 24.4L13 27.333L10.8 24.4C10.7029 24.2818 10.5808 24.1865 10.4424 24.1211C10.3041 24.0558 10.153 24.0219 10 24.0219C9.847 24.0219 9.69589 24.0558 9.55756 24.1211C9.41924 24.1865 9.29712 24.2818 9.2 24.4L7 27.333V4H25V27.333Z"
              fill="black"
            />
          </svg>
        </div>
        <h4 class="f-500 hidden-sm f-18">3. {{ $t('See payments') }}</h4>
        <h4 class="f-500 visible-sm f-14">3. {{ $t('See payments') }}</h4>
        <p class="f-14 f-300 m-0">
          {{ $t('View the status of the invoices from your placements.') }}
        </p>
      </div>
    </div>

    <div class="cta text-center">
      <a :href="laravelNamedRoute(namedRoutes['recruiter-candidates'].index)">
        <WdsButton primary lg>
          {{ $t('Add my candidates') }}
        </WdsButton>
      </a>
    </div>
  </div>
</template>

<script setup>
import { WdsButton } from '@worksome/wds-components'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
</script>
